// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__xC2Cl","clinicsSelect":"TableHeading_clinicsSelect__1PE-k"};